export const ErrorMessages = {
    apiFailedErrorMessage: "Oops, Something went wrong. Please try again after some time",
    inValidEmailError:
        "Email ID Required : To continue, please add or verify a valid email address on the login & security screen.",
    inValidMobileNumberError:
        "Mobile Number Required : To continue, please add or verify a valid mobile number on the login & security screen.",
    userNotLoggedInError: "You are not logged in. Redirecting to login screen...",
    somethingWentWrong: "Something went wrong"
};